<template>
  <div>
    <transition name="slide-in-left">

      <div 
        v-show="$store.state.isBottomBarVisible"
        class="right-sidebar"
        :class="{ 'dir-rtl' : language.rtl }"
        :dir="language.rtl ? 'rtl' : 'ltr'"
        @click="clearTimeout"
      >

        <div class="right-sidebar__brand-logo">
          <img :src="`${$store.state.assetsPath}${config.generalSidebarBrandLogo}`">
        </div>

        <div class="right-sidebar__layout">
          <transition-group
            name="sidebar-fade"
            tag="div"
            class="right-sidebar__content"
          >
        
            <div v-if="activeContent.minimapImage" :key="activeContent.minimapImage"  class="right-sidebar__minimap-wrapper">
                <img :key="activeContent.minimapImage" :src="`${$store.state.assetsPath}${activeContent.minimapImage}`" class="right-sidebar__minimap">
            </div>
            <div
              v-if="activeContent.heading"
              :key="activeContent.heading"
              class="right-sidebar__heading"
              v-html="activeContent.heading"
            />
            <div
              v-if="activeContent.description"
              :key="activeContent.description"
              class="right-sidebar__description"
              v-html="activeContent.description"
            />  

          </transition-group>          

          <div class="spacer"></div>

          <transition-group
            name="sidebar-fade"
            tag="div"
            class="right-sidebar__content"
          >

            <SidebarSubnavigation
              class="right-sidebar__subnav"
              v-if="projectConfig.useSidebarSubnavigation && $store.getters.activeSubBottomBar.length > 1"
              key="subnav"
              :nav-items="$store.getters.activeSubBottomBar"
            />
            <SidebarSubnavigation
              class="right-sidebar__subnav"
              v-if="projectConfig.useSidebarSubnavigation && productNavigationItems.length > 1"
              key="productNavigationItems"
              :nav-items="productNavigationItems"
            />            
            <div
              v-if="styles['right-sidebar']['property-guide'].active &&
                    activeContent.markerGuide && 
                    !projectConfig.useSidebarSubnavigation"
              :key="activeContent.markerGuide"
              class="right-sidebar__marker-guide"
              :style="`color: ${styles['right-sidebar']['description-colour']};`"
            >
              <div v-for="item in styles['right-sidebar']['property-guide'].items" :key="item.en" class="guide">
                <div
                  class="guide__icon guide__icon--available"
                  :class="[{
                    'guide__icon--available': item.en === 'Available',
                    'guide__icon--builder': item.en === 'Builder Lots' || item.en === 'Coming Soon',
                    'guide__icon--on-hold': item.en === 'On Hold',
                    'guide__icon--on-hold': item.en === 'Not Released',
                    'guide__icon--sold': item.en === 'Sold',
                    'guide__icon--homeseeker': item.en === 'Home Seeker',
                  }]"
                >
                  <fa v-if="item.en === 'Available'" class="check" :icon="['far', 'check']" />
                  <fa v-if="item.en === 'Builder Lots'" class="check" :icon="['far', 'check']" />
                  <fa v-if="item.en === 'Coming Soon'" class="check" :icon="['fas', 'shovel']" />
                  <fa v-if="item.en === 'On Hold'" class="check" :icon="['far', 'horizontal-rule']" />
                  <fa v-if="item.en === 'Not Released'" class="check" :icon="['far', 'horizontal-rule']" />
                  <fa v-if="item.en === 'Sold'" class="check" :icon="['far', 'horizontal-rule']" />
                  <fa v-if="item.en === 'Home Seeker'" class="check" :icon="['far', 'check']" />
                </div>
                <div class="guide__label">{{ item[language.code] || item['en'] }}</div>
              </div>
            </div>
            <div
              v-if="activeContent.qrUrl"
              :key="activeContent.qrUrl"
              class="right-sidebar__qr-wrapper"
            >
              <div class="right-sidebar__qr">
                <div class="right-sidebar__qr-heading" v-html="activeContent.qrHeading" />
                <div class="right-sidebar__qr-row">
                  <qrcode-vue
                    class="qrcode"
                    :value="activeContent.qrUrl"
                    size="1000"
                    renderAs="canvas" 
                    :key="activeContent.qrUrl"
                  />
                  <div class="right-sidebar__qr-message">{{ activeContent.qrMessage }}</div>
                </div>
              </div>

              <div>
                <button class="btn btn--email touch" @click="$store.commit('SET_IS_EMAIL_MODAL_ACTIVE', !$store.state.isEmailModalActive)">
                  <template v-if="language.code === 'en'">
                    Enter Email
                  </template>
                  <template v-if="language.code === 'ar'">
                    Enter Email
                  </template>
                </button>
              </div>
            </div>

            <div
              v-if="activeContent.virtualTourUrl"
              :key="activeContent.virtualTourUrl"
              class="right-sidebar__qr-wrapper"
            >
              <div class="right-sidebar__qr">
                <div class="right-sidebar__qr-row">
                  <button class="btn touch" @click="$store.commit('property/SET_ACTIVE_VIRTUAL_TOUR_URL', activeContent.virtualTourUrl)">{{ activeContent.virtualTourButtonLabel.en }}</button>
                </div>
              </div>
            </div>
          </transition-group>

          <div v-if="activeSubsection && (activeSubsection.issuuEmbedUrl[language.code] || activeSubsection.issuuEmbedUrl.en)" class="right-sidebar__back-wrapper">
            <button
              v-if="!$store.state.actions.showIframeUrl"
              class="btn touch"
              @click="$store.commit('actions/SET_IFRAME_URL', activeSubsection.issuuEmbedUrl[language.code] || activeSubsection.issuuEmbedUrl.en); $store.commit('sidebar/CLOSE_SLIDEOUT')"
            >
              <span>{{ labels.viewBrochure[language.code] || labels.viewBrochure['en'] }}</span>
            </button>
            <button
              v-else
              class="btn touch"
              @click="$store.commit('actions/SET_IFRAME_URL', false)"
            >
              <span>{{ labels.closeBrochure[language.code] || labels.closeBrochure['en'] }}</span>
            </button>
          </div>

          <div v-if="activeContent && activeContent.issuuEmbedUrl" class="right-sidebar__back-wrapper">
            <button
              v-if="!$store.state.actions.showIframeUrl"
              class="btn touch"
              @click="$store.commit('actions/SET_IFRAME_URL', activeContent.issuuEmbedUrl); $store.commit('sidebar/CLOSE_SLIDEOUT')"
            >
              <span>{{ labels.viewBrochure[language.code] || labels.viewBrochure['en'] }}</span>
            </button>
            <button
              v-else
              class="btn touch"
              @click="$store.commit('actions/SET_IFRAME_URL', false)"
            >
              <span>Close Brochure</span>
            </button>
          </div>

          <div v-if="projectConfig.general.disclaimer" class="right-sidebar__disclaimer" v-html="projectConfig.general.disclaimer"></div>
        </div>
        <div v-if="config.generalSidebarLogo" class="right-sidebar__logo">
          <img :src="`${$store.state.assetsPath}${config.generalSidebarLogo}`">
        </div>
      </div>
    </transition>
  </div>
</template>
<script>
import { mapActions, mapGetters, mapState } from 'vuex'
import QrcodeVue from 'qrcode.vue'
import _ from 'lodash'
import { bus } from '../main'
import SidebarSubnavigation from './SidebarSubnavigation.vue'

export default {
  props: ['content'],

  components: { SidebarSubnavigation, QrcodeVue },

  data () {
    return {
      activeContent: {},
      backButtonLabel: {
        en: 'Back',
        ar: 'سابق'
      }
    }
  },

  computed: {
    ... mapState({
      labels: 'labels'
    }),

    ...mapGetters({
      activeSubsection: 'property/activeSubsection',
      activeLivingOption: 'property/activeLivingOption',
      config: 'config',
      backlink: 'activeBackLink',
      styles: 'styleTemplate',
      subnav: 'activeSubBottomBar',
      shouldSlideOutAutoOpen: 'sidebar/shouldSlideOutAutoOpen',
      projectConfig: 'projectConfig',
      language: 'language',
    }),

    activeSubsectionId () {
      return this.$store.state.route.query.activeSubsectionId
    },

    isSlideOutVisible () {
      return this.$store.getters['sidebar/isSlideOutVisible']
    },

    language () {
      return this.$store.getters.language
    },

    env () {
      return process.env
    },

    productNavigationItems () {
      const params = this.$route.params
      if (this.$route.name === 'living-entry') {
        return _.sortBy(this.$store.getters['property/livingOptions'], livingOption => livingOption.label)
        .map(livingOption => {
          return {
            _id: livingOption._id,
            label: livingOption.displayName,
            to: this.getLivingOptionNavigationPath(livingOption),
            filter: !this.shouldDisplay(livingOption)
          }
        })
      }

      if (this.$route.name === 'living-option') {
        const activeLivingOption = this.$store.getters['property/activeLivingOption']
        if (!activeLivingOption) return []
        return activeLivingOption.subsections.map(subsection => {
          return {
            _id: subsection._id,
            label: subsection.displayName,
            to: `/category/${params.categoryId}/live/${params.pathway}/${params.livingOptionId}/subsection/${subsection._id}`,
            filter: !this.shouldDisplay(subsection)
          }
        }).sort(livingOption => livingOption.label.en)
      }

      if (this.$route.name === 'subsection' || this.$route.name === 'property') {
        const activeSubsection = this.$store.getters['property/activeSubsection']
        // handle nested subsections
        if (activeSubsection.subsections && activeSubsection.subsections.length) {
          return activeSubsection.subsections.map(subsection => {
            return {
              _id: subsection._id,
              label: subsection.displayName,
              to: `/category/${params.categoryId}/live/${params.pathway}/${params.livingOptionId}/subsection/${subsection._id}?parentSubsectionId=${subsection.parent.id}`,
              filter: !this.shouldDisplay(subsection)
            }
          })
        // keep showing subsections from parent in sidebar
        } else {
          if (activeSubsection.parent.type === 'livingOption') {
            const activeLivingOption = this.$store.getters['property/activeLivingOption']
            if (!activeLivingOption) return []

            return activeLivingOption.subsections.map(subsection => {
              return {
                _id: subsection._id,
                label: subsection.displayName,
                to: `/category/${params.categoryId}/live/${params.pathway}/${params.livingOptionId}/subsection/${subsection._id}`,
                filter: !this.shouldDisplay(subsection)
              }
            })
          } else {
            const parentSubsection = this.$store.getters['property/subsections'].find(subsection => subsection._id === activeSubsection.parent.id)
            return parentSubsection.subsections.map(subsection => {
              return {
                _id: subsection._id,
                label: subsection.displayName,
                to: `/category/${params.categoryId}/live/${params.pathway}/${params.livingOptionId}/subsection/${subsection._id}?parentSubsectionId=${subsection.parent.id}`,
                filter: !this.shouldDisplay(subsection)
              }
            })
          }
        }
      }      

      return []
    }
  },

  watch: {
    content: {
      handler (newContent, oldContent) {
        if (!_.isEqual(oldContent, newContent)) {
          if (!_.isEmpty(oldContent)) {
            this.activeContent = {}
          }

          if (!_.isEmpty(newContent)) {
            this.$store.commit('addAnimationToQueue', 'SideBar')
          }
        }
      },
      immediate: true
    }
  },

  mounted () {
    bus.$on('animateSideBar', () => {
      if (!_.isEqual(this.activeContent, this.content)) {
        setTimeout(() => {
          this.activeContent = this.content
          bus.$emit('finishedAnimation', 'SideBar')
        }, 500)
      } else {
        bus.$emit('finishedAnimation', 'SideBar')
      }

      if (this.shouldSlideOutAutoOpen) {
        setTimeout(() => {
          this.$store.commit('sidebar/OPEN_SLIDEOUT')
        }, 2000)
      }
    })
  },

  methods: {
    ...mapActions([
      'triggerVideo',
    ]),

    getLivingOptionNavigationPath (livingOption) {
      const params = this.$route.params
        if (livingOption.subsections.length === 1) {
          return `/category/${params.categoryId}/live/${params.pathway}/${livingOption._id}/subsection/${livingOption.subsections[0]._id}`
        } else {
          return `/category/${params.categoryId}/live/${params.pathway}/${livingOption._id}`
        }
    },

    shouldDisplay(collection) {
      if (collection.label === 'Marina Beach District') return true
      if (collection.label === 'Azura Beach Residences') return true
      if (collection.label === 'Azura Beach Apartments') return true
      if (collection.label === 'Azura Beach Chalets') return true
      // if (!collection.availablePropertiesCount) return false
      // if (!collection.properties) return false
      let shouldDisplay = false
      if (
        !this.$store.getters['filter/inputType'] &&
        !this.$store.getters['filter/inputBeds'] &&
        !this.$store.getters['filter/inputView']
      ) {
        shouldDisplay = true
      }
      collection.properties.forEach(property => {
        if (this.$store.getters['filter/inputType']) {
          const dwelling = this.$store.getters['property/dwellings'].find(dwelling => dwelling._id === property.dwellingId)
          if (dwelling && dwelling.type.toLowerCase() === this.$store.getters['filter/inputType'].toLowerCase()) {
            shouldDisplay = true
          }
        }

        if (this.$store.getters['filter/inputBeds']) {
          const dwelling = this.$store.getters['property/dwellings'].find(dwelling => dwelling._id === property.dwellingId)
          if (dwelling) {
            let beds = parseInt(dwelling.beds)
            if (beds > 4) beds = 4
            if (beds === this.$store.getters['filter/inputBeds']) {
              shouldDisplay = true
            }
          }
        }

        if (this.$store.getters['filter/inputView']) {
          if (this.$store.getters['filter/inputView'].toLowerCase() === property.viewLabel.toLowerCase()) {
            shouldDisplay = true
          }
        }
      })
      return shouldDisplay
    },

    clearTimeout () {
      this.$store.commit('sidebar/CLEAR_SIDEBAR_CLOSE_TIMEOUT')
    },

    isNavItemActive (item) {
      if (this.$route.fullPath === item.to) {
        return true
      }
    },

    toggleSlideOut () {
      if (!this.$store.state.property.activeVirtualTourUrl) {
        if (this.isSlideOutVisible) {
          this.$store.commit('sidebar/CLOSE_SLIDEOUT')
        } else {
          this.$store.commit('sidebar/OPEN_SLIDEOUT')
        }
      }
    }
  }
}
</script>
<style lang="scss">
@import "@/styles/_mixins.scss";
@import "@/styles/_variables.scss";
@import "@/styles/_buttons.scss";

.right-sidebar {
  background: $sidebar-bg-color;
  height: 98rem;
  position: absolute;
  right: 0;
  top: 0;
  width: 32.5rem;
  z-index: 100;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  .spacer {
    flex-grow: 1;
  }

  .layout-switched & {
    top: 10rem;
  }

  &__layout {
    display: flex;
    flex-direction: column;
    height: 100%;
    padding: 2rem 3rem 1rem;
  }

  &__brand-logo {

    img {
      height: 100%;
      object-fit: contain;
      width: 100%;
    }
  }

  &__logo {
    bottom: 0;
    height: 5rem;
    position: absolute;
    right: 0;
    width: calc(100% - 5rem);
    z-index: 20;

    img {
      height: 100%;
      object-fit: contain;
      object-position: bottom right;
      width: 100%;
    }
  }  

  &__minimap-wrapper {
    position: relative;
    padding-bottom: 3rem;
  }

  &__minimap {
    // width: 100%;
    border-radius: 0.5rem;
    width: 100%;
  }

  &__heading {
    color: #fff;
    font-size: 1.8rem;
    font-weight: 400;
    letter-spacing: 0.05em;
    line-height: 1.2;
    padding-bottom: 1rem;
    padding-left: 5rem;
    padding-right: 5rem;
    // position: absolute;
    top: 0;
    left: 0;
    // height: 100%;
    width: 100%;
    text-transform: uppercase;
    margin-bottom: 1rem;
  }

  &__description-wrapper {
    position: relative;
  }

  &__description {
    font-size: 1.1rem;
    font-weight: 400;
    letter-spacing: 0.05em;
    line-height: 1.5rem;
    margin: 0 0 1rem;
    padding-left: 5rem;
    padding-right: 5rem;
    width: 100%;
    margin-bottom: 1rem;

    ul {
      padding-inline-start: 0;
    }
  }

  &__subnav {
    margin-bottom: 2rem;
    margin-top: 2rem;
  }

  &__disclaimer {
    font-size: .5rem;
    font-weight: 400;
    letter-spacing: 0.05em;
    line-height: 1.1em;
    opacity: .15;
    font-style: italic;
    width: 100%;
    z-index: 10;
    margin-top: 2rem;
  }

  &__marker-guide {
    font-size: 1.1rem;
    font-weight: 400;
    letter-spacing: 0.05em;
    line-height: 1.5rem;
    margin: 2rem 0 1rem;
    padding-left: 5rem;
    padding-right: 5rem;
    width: 100%;

    .guide {
      align-items: center;
      display: flex;
      margin: 0 0 1rem;

      &__icon {
        border-radius: 50%;
        border: 0.2rem solid white;
        box-shadow: -0.2rem 0.3rem 0.3rem rgba(0, 0, 0, .35);
        height: 2rem;
        position: relative;
        width: 2rem;

        &--available {
          background: #6ed46b;

          svg {
            color: white;
          }
        }

        &--builder {
          background: $marker-builder;

          svg {
            color: $black;
          }
        }

        &--on-hold {
          background: $marker-on-hold;

          svg {
            color: $white;
            width: 60%;
          }
        }

        &--sold {
          background: $marker-sold;

          svg {
            color: $white;
            width: 60%;
          }
        }

        &--homeseeker {
          background: $marker-homeseeker;

          svg {
            color: $white;
          }
        }

        svg {
          font-size: 1.2em;
          left: 50%;
          position: absolute;
          top: 50%;
          transform: translate(-50%, -50%);
        }
      }

      &__label {
        font-size: 0.8rem;
        margin: 0 0 00 .75rem;
        text-transform: uppercase;

        [dir="rtl"] & {
          margin: 0 0.75rem 0 0;
        }
      }
    }
  }

  &__back-wrapper {
    margin: 2rem 0 1rem;
    padding-left: 5rem;
    padding-right: 5rem;
    width: 100%;
  }

  &__back {
    opacity: 1;

    svg {
      margin-left: 0;
      margin-right: 1rem;

      [dir="rtl"] & {
        margin-left: 1rem;
        margin-right: 0;
      }
    }

    
  }

  &__qr-wrapper {
    position: relative;

    .btn--email {
      border: 0.1rem solid #fff;
      border-radius: 0.5rem;
      font-size: 1.2rem;
      margin: 1rem 0 0;
      padding: 1rem 2rem;
    }
  }

  &__qr {
    margin: 2rem 0 1rem;
    padding-left: 5rem;
    padding-right: 5rem;
    width: 100%;

    &-heading {
      font-size: 1.2rem;
      font-weight: 200;
      margin-bottom: 1.2rem;
      text-transform: uppercase;
      letter-spacing: 0.05em;
    }

    &-row {
      display: flex;
      // height: 6.75rem;
    }

    &-message {
      font-size: 1.1rem;
      font-weight: 400;
      letter-spacing: 0.05em;
      line-height: 1.5rem;
    }
  }

  .qrcode {
    background: $white;
    display: inline-block;
    padding: 0.4rem;
    font-size: 0;;

    canvas {
      height: 10rem !important;
      width: 10rem !important;
    }
  }  
}



.bottom-bar__nav-item-wrapper a {
  pointer-events: auto;
}
</style>